export enum RestApiQueryParameter {
  PREFIX = "prefix",
  LANGUAGE = "language",
}
